export default  {
    首页:{
        首页:"首页",
        产品:"产品",
        场景:"场景",
        可持续发展:"可持续发展",
        联系我们:"联系我们",


        "引领智能餐饮新生态":"引领智能餐饮新生态",
        "为校园、企业、医院、商超等场景":"为校园、企业、医院、商超等场景",
        "提供2-4分钟现蒸热食24/7可运营的自动热食供应方案":"提供2-4分钟现蒸热食，24/7可运营的自动热食供应方案",
        "观看视频演示":"观看视频演示",



        "智能餐饮新生态":"智能餐饮新生态",
        "智能餐饮设备":"智能餐饮设备",
        "24小时在线的智慧无人厨房，触手可及的餐饮新体验":"24小时在线的智慧无人厨房，触手可及的餐饮新体验",
        "食材供应链":"食材供应链",
        "从源头锁鲜的直供网络，安心可溯的品质基石":"从源头锁鲜的直供网络，安心可溯的品质基石",
        "高效运营":"高效运营",
        "云端协同的智能运维系统，保障全局的高效运转":"云端协同的智能运维系统，保障全局的高效运转",
        "数字化平台":"数字化平台",
        "洞察需求的AI数据大脑，驱动生态的智慧核心":"洞察需求的AI数据大脑，驱动生态的智慧核心",

        "我们的发展历程":"发展历程",
        "启航奠基":"启航 | 奠基",
        "公司于杭州成立":"公司于杭州成立",
        '确立以全自动智能化商用鲜食机为核心的发展方向':'确立以全自动智能化商用鲜食机为核心的发展方向',
        '提出"科技传承美食，数据驱动变革"的企业使命':'提出"科技传承美食，数据驱动变革"的企业使命',
        "深耕攻坚":"深耕 | 攻坚",

        "集中研发力量，攻坚底层核心技术":"集中研发力量，攻坚底层核心技术",
        "突破蒸煮温控算法、食材保鲜系统等关键难题":"突破蒸煮温控算法、食材保鲜系统等关键难题",
        "为产品智能化与量产化奠定坚实基础":"为产品智能化与量产化奠定坚实基础",
        "突破绽放":"突破 | 绽放",
        "V31蒸煮一体机成功量产，并进军德国慕尼黑市场":"V31蒸煮一体机成功量产，并进军德国慕尼黑市场",
        "V21煮面机完成迭代":"V21煮面机完成迭代",
        "V41桌面蒸煮一体机开发完成":"V41桌面蒸煮一体机开发完成",
        "未来":"未来",
        "拓展引领":"拓展 | 引领",
        "产品开发:以AI为决策核心，以大数据为优化引擎，驱动产品矩阵迭代升级":"产品开发:以AI为决策核心，以大数据为优化引擎，驱动产品矩阵迭代升级",
        "市场开拓:以德国市场为基点，迈向全球，携手合作伙伴共建智能餐饮新生态":"市场开拓:以德国市场为基点，迈向全球，携手合作伙伴共建智能餐饮新生态",


        "视频加载中，请稍候...":"视频加载中，请稍候...",
        "视频加载失败，请刷新重试":"视频加载失败，请刷新重试",

        "产品矩阵":"产品矩阵",
        "智能餐食站":"智能餐食站",
        "您的24小时现代化餐饮解决方案伙伴":"您的24小时现代化餐饮解决方案伙伴",
        "空间高效，灵活布局":"空间高效，灵活布局",
        "运维经济，全天候服务":"运维经济，全天候服务",
        "模块组合，按需定制":"模块组合，按需定制",
        "提升体验，增值空间":"提升体验，增值空间",
        "鲜食售货机":"蒸煮一体机",
        "煮面机":"煮面机",
        "冰淇淋机":"冰淇淋机",
        "零食饮料机":"零食饮料机",
        "饮品机":"饮品机",



        "多样化菜单":"多样化菜单",
        "菜单定期更新、支持定制，覆盖多地区口味与饮食文化":"菜单定期更新、支持定制，覆盖多地区口味与饮食文化",
        "盖饭":"盖饭",
        "炒饭":"炒饭",
        "拌面":"拌面",
        "汤面":"汤面",
        "饺子":"饺子",
        "虾饺":"虾饺",
        "包子":"包子",
        "烧麦":"烧麦",
        "意面":"意面",
        "关东煮":"关东煮",
        "咖喱饭":"咖喱饭",
        "冬阴功汤":"冬阴功汤",
        "芝士蛋糕":"芝士蛋糕",
        "慕斯蛋糕":"慕斯蛋糕",
        "甜羹":"甜羹",
        "甜包":"甜包",



        "产品优势":"产品优势",
        "随取随热减少浪费":"随取随热减少浪费",
        "按需制作，避免食物浪费，节省成本。":"按需制作，避免食物浪费，节省成本。",
        "无需厨房，降低运营成本":"无需厨房，降低运营成本",
        "3平米即可部署，无需厨师与复杂厨房设施。":"2㎡即可部署，无需厨师与复杂厨房设施。",
        "24-7全天候服务":"24-7全天候服务",
        "填补夜间、假日等非高峰时段餐饮空白。":"填补夜间、假日等非高峰时段餐饮空白。",
        "菜单灵活，适配多样人群":"菜单灵活，适配多样人群",
        "支持多地风味，满足不同饮食需求。":"支持多地风味，满足不同饮食需求。",
        "远程管理，智能运维":"远程管理，智能运维",
        "通过手机或电脑实时监控设备状态与销售数据。":"通过手机或电脑实时监控设备状态与销售数据。",


        "丰富的应用场景":"丰富的应用场景",


        "合作伙伴":"合作伙伴",


        "智能餐饮 绿色未来":"智能餐饮 绿色未来",
        "Homierobot在设计之初即考虑餐饮运营中的可持续需求，通过减少食物浪费、优化资源使用，并支持符合欧盟法规的包装方案，帮助运营方更轻松地实现合规与环保目标。"
            :"Homierobot在设计之初即考虑餐饮运营中的可持续需求，通过减少食物浪费、优化资源使用，并支持符合欧盟法规的包装方案，帮助运营方更轻松地实现合规与环保目标。",

        "减少浪费":"减少浪费",
        "按需出餐，精准供应":"按需出餐，精准供应",

        "高效节能":"高效节能",
        "紧凑设计，智能温控":"紧凑设计，智能温控",

        "环保包装":"环保包装",
        "支持可降解、可循环餐盒":"支持可降解、可循环餐盒",



        "合作咨询":"合作咨询",
        "我们欢迎与运营方、经销商及各类合作伙伴展开合作，探索自动热食在不同场景下的试点与落地。":"我们欢迎与运营方、经销商及各类合作伙伴展开合作，探索自动热食在不同场景下的试点与落地。",
        "姓":"姓",
        "名":"名",
        "邮箱":"邮箱",
        "公司":"公司",
        "职务/部门":"职务/部门",
        "手机号":"手机号",
        "咨询内容":"咨询内容",
        "提交信息":"提交信息",
        "邮箱不能为空":"邮箱不能为空",
        "请输入正确的邮箱地址":"请输入正确的邮箱地址",
        "请填写":"请填写",
        "提交成功,请等待我们的联系":"提交成功,请等待我们的联系",

        "WhatsApp":"联系电话",
        "Email":"企业邮箱",

        "回到顶部":"回到顶部",
    }
}
